import { render, staticRenderFns } from "./SettingsKeys.vue?vue&type=template&id=1e4e5d86&scoped=true"
import script from "./SettingsKeys.vue?vue&type=script&lang=js"
export * from "./SettingsKeys.vue?vue&type=script&lang=js"
import style0 from "./SettingsKeys.vue?vue&type=style&index=0&id=1e4e5d86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4e5d86",
  null
  
)

export default component.exports